var alignment_rtlignore_default = {
  "alignLeft": "_4dVbu",
  "textWrapNowrap": "Dezxt",
  "alignRight": "_1v8HE",
  "alignCenter": "l3-pK",
  "sizeFullWidth": "aDCqr",
  "renderedInTable": "q4fEo",
  "sizeOriginal": "KTmeM",
  "sizeContent": "cHLjv",
  "sizeSmall": "kiybE",
  "sizeSmallCenter": "LkFD4",
  "flex": "zxsZE",
  "LEFT": "FtZ4z",
  "CENTER": "V46-x",
  "RIGHT": "pjmwy",
  "AUTO": "pdn8y",
  "JUSTIFY": "A-P-4"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
